import Errors from './errors';

export default class {
  /**
   * Create a new Form instance.
   *
   * @param {object} data
   */
  constructor(data) {
    this.originalData = data;

    this.request = false;

    for (let field in data) {
      this[field] = data[field];
    }

    this.errors = new Errors();
  }


  /**
   * Fetch all relevant data for the form.
   */
  data(requestType) {
    let data = {};

    for (let property in this.originalData) {
      data[property] = this[property];
    }

    if (requestType && requestType === 'get') {
      data = {
        params: data
      };
    }

    return data;
  }


  /**
   * Reset the form fields.
   */
  reset() {
    for (let field in this.originalData) {
      this[field] = '';
    }

    this.errors.clear();
  }


  /**
   * Send a POST request to the given URL.
   * .
   * @param {string} url
   * @param {boolean} needReset
   */
  get(url, needReset) {
    return this.submit('get', url, needReset);
  }


  /**
   * Send a POST request to the given URL.
   * .
   * @param {string} url
   * @param {boolean} needReset
   */
  post(url, needReset) {
    return this.submit('post', url, needReset);
  }


  /**
   * Send a PUT request to the given URL.
   * .
   * @param {string} url
   * @param {bollean} needReset
   */
  put(url, needReset) {
    return this.submit('put', url, needReset);
  }


  /**
   * Send a PATCH request to the given URL.
   * .
   * @param {string} url
   * @param {boolean} needReset
   */
  patch(url, needReset) {
    return this.submit('patch', url, needReset);
  }


  /**
   * Send a DELETE request to the given URL.
   * .
   * @param {string} url
   * @param {boolean} needReset
   */
  delete(url, needReset) {
    return this.submit('delete', url, needReset);
  }


  /**
   * Submit the form.
   *
   * @param {string} requestType
   * @param {string} url
   * @param {boolean} needReset
   */
  submit(requestType, url, needReset = true) {
    this.setRequest();

    return new Promise((resolve, reject) => {
      axios[requestType](url, this.data(requestType))
        .then(response => {
          this.unsetRequest();

          this.onSuccess(response.data, needReset);

          resolve(response.data);
        })
        .catch(error => {
          this.unsetRequest();

          if (error.response.data.errors) {
            this.onFail(error.response.data.errors);

            reject(error.response.data.errors);
          } else {
            this.onFail(error.response.data);

            reject(error.response.data);
          }
        });
    });
  }


  setRequest() {
    this.request = true;
  }


  unsetRequest() {
    this.request = false;
  }


  /**
   * Handle a successful form submission.
   *
   * @param {object} data
   * @param {boolean} needReset
   */
  onSuccess(data, needReset) {
    if(needReset) {
      this.reset();
    }
  }


  /**
   * Handle a failed form submission.
   *
   * @param {object} errors
   */
  onFail(errors) {
    this.errors.record(errors);
  }
}
